import type { resourceBundle } from '../types/hippoTypes';
import { getHippoResourceBundleSelector } from '../selectors/getHippoResourceBundleSelector';
import { atom } from 'recoil';

export const hippoResourceAtom = atom<resourceBundle>({
    key: 'resourceBundles',
    default: getHippoResourceBundleSelector
});
